import {
  SectionElement,
  defineElement,
  globalOn,
  liquidValue,
  query,
  queryAll
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-RGTSXKO2.js";

// src/sections/common-product-slider/common-product-slider.ts
var CommonProductSlider = class extends SectionElement {
  connectedCallback() {
    console.log({ recommendation: this.recommendation });
    if (!this.recommendation)
      return;
    this.fetchRecommendations();
  }
  fetchRecommendations() {
    return __async(this, null, function* () {
      var _a;
      try {
        const response = yield fetch((_a = this.getAttribute("data-url")) != null ? _a : "");
        const text = yield response.text();
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("common-product-slider");
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }
      } catch (e) {
        console.error(e);
      }
    });
  }
  init() {
    var _a, _b;
    (_b = this.querySelector(`[data-gray-bullet="${(_a = this.swiper.swiperInstance) == null ? void 0 : _a.realIndex}"]`)) == null ? void 0 : _b.setAttribute("data-gray-active", "true");
    this.swiper.swiperInstance.on("slideChange", () => {
      this.updateBullets();
    });
  }
  updateBullets() {
    var _a, _b, _c;
    this.querySelectorAll("[data-gray-bullet]").forEach((bullet) => bullet.removeAttribute("data-gray-active"));
    const activeGrayBullet = (_c = this.grayBullets) == null ? void 0 : _c.filter((elm) => getComputedStyle(elm).display !== "none")[(_b = (_a = this.swiper.swiperInstance) == null ? void 0 : _a.realIndex) != null ? _b : 0];
    activeGrayBullet == null ? void 0 : activeGrayBullet.setAttribute("data-gray-active", "");
  }
};
__decorateClass([
  liquidValue("section.settings.recommendation")
], CommonProductSlider.prototype, "recommendation", 2);
__decorateClass([
  query("[data-product-swiper]")
], CommonProductSlider.prototype, "swiper", 2);
__decorateClass([
  queryAll("[data-gray-bullet]")
], CommonProductSlider.prototype, "grayBullets", 2);
__decorateClass([
  globalOn("productSlider:init")
], CommonProductSlider.prototype, "init", 1);
CommonProductSlider = __decorateClass([
  defineElement("common-product-slider")
], CommonProductSlider);
export {
  CommonProductSlider
};
